var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"dialogs"}},[_c('assistance-dialog'),_c('intro-dialog'),_c('test-marker-dialog'),_c('video-dialog'),_c('tour')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }